import { render, staticRenderFns } from "./orderStatus.vue?vue&type=template&id=3d4737fa&scoped=true&"
import script from "./orderStatus.vue?vue&type=script&lang=js&"
export * from "./orderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4737fa",
  null
  
)

export default component.exports